<wiz-vgroup
  width="100%"
  height="100%"
  horizontalAlign="center"
  gap="2"
  class="section-container"
  [style.background]="lineBackground"
>
  <wiz-hgroup width="100%" height="26px" verticalAlign="center" padding="0px" gap="5">
    <wiz-checkbox [wizShowLabel]="false" [manageModel]="false" [wizChecked]="isSelected()"></wiz-checkbox>
    <wiz-icon (click)="askForEdit($event)" [visible]="mayEdit()" [wizTooltip]="'$.tab.edit.$'" class="image-purple">icon-edit</wiz-icon>
    <wiz-hgroup width="100%">
        <wiz-label
        #lbTitle
        width="100%"
        [wizLabel]="label"
        [tooltipText]="label"
        [wizTextBehavior]="'truncate'"
        class="componentLabel"
      ></wiz-label>
    </wiz-hgroup>
    <wiz-icon (click)="askForDelete($event)" [visible]="mayDelete()" [wizTooltip]="'$.common.delete.$'" class="image-purple">icon-delete</wiz-icon>
  </wiz-hgroup>
  <wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center">
    <!-- <wiz-icon [hidden]="!wizIcon" style="font-size: 18px">{{wizIcon}}</wiz-icon> -->

    <wiz-image style="padding: 3px; object-fit: cover; border-radius: 3px; margin-right: 5px; padding-right: 5px; aspect-ratio: 1"
              [hidden]="!wizImage"
              #img
              tabindex="0"
              height="100%"
              [sourceObservable]="wizImage">

    </wiz-image>

    <wiz-icon class="inner-icon" [hidden]="!wizIcon" style="margin-right: 5px; padding-right: 5px;" [style.color]="color">
      {{wizIcon}}</wiz-icon>
    <mat-icon [hidden]="!wizMaterial" 
    style="margin-right: 5px; padding-right: 5px; font-size: 20;"
    [style.color]="color">{{wizMaterial}}</mat-icon>


    <wiz-label
      #lbContent
      [wizLabel]="description"
      width="100%"
      padding="3px"
      [wizNbLine]="3"
      [wizTextBehavior]="'wordWrap'"
      style="font-size: 9px"
    ></wiz-label>
  </wiz-hgroup>
</wiz-vgroup>
